export enum MessageType {
  REGISTRATION = 'registration',
  SIGNIN = 'signIn',
  PUSH_NOTIFICATION = 'pushNotification',
}
